/* eslint-disable @typescript-eslint/ban-types */
import CTNAvatar from '@ctn/ui/components/ctn-avatar';
import CTNTag from '@ctn/ui/components/ctn-tag';
import classNames from 'classnames';
import { type MouseEventHandler, type Ref, useEffect, useState } from 'react';

import { ROUTES_RESOURCES } from '@/constants/routes.constants';
import type { IMaestro } from '@/interfaces/model/maestros.interface';
import type { IUserAuth } from '@/interfaces/model/user.interface';
import { getBase64FromUrl } from '@/utils/file.utils';

export const UserMini = ({
	user,
	rol,
	ref,
	onClick,
	isReverse,
	className,
}: {
	readonly ref: Ref<HTMLButtonElement | null>;
	readonly user: IUserAuth;
	readonly rol: IMaestro[];
	readonly onClick?: MouseEventHandler<HTMLButtonElement>;
	readonly isReverse?: boolean;
	readonly className?: string;
}) => {
	const [base64Image, setBase64Image] = useState<string>();

	const { nombre, apellido1, apellido2, nombreEmisor, idRol } = user ?? {};
	const classNameComponent = classNames(className, 'o-media c-pnp-user-mini', {
		['o-media--reverse']: isReverse,
	});

	useEffect(() => {
		const convertToBase64 = async (imagePath: string) => {
			try {
				const base64String = await getBase64FromUrl(imagePath);
				setBase64Image(`data:image/svg+xml;base64,${base64String}`);
			} catch (error) {
				console.error('Error converting image to Base64:', error);
			}
		};
		const avatarEmptyUrl = `${ROUTES_RESOURCES.IMAGES}/avatar-empty.svg`;
		convertToBase64(avatarEmptyUrl);
	}, [user]);

	return (
		<button ref={ref} className={classNameComponent} type="button" onClick={onClick}>
			<CTNAvatar
				className="[ o-media__img ] [ c-pnp-user-mini__avatar ]"
				type="basic"
				image={base64Image}
				size="size-32"
			/>
			<div className="[ o-media__body ] [ c-pnp-user-mini__data ]">
				<p className="c-pnp-user-mini__tit">
					{nombre} {apellido1} {apellido2}
				</p>
				{nombreEmisor && <p className="c-pnp-user-mini__subtit">{nombreEmisor}</p>}
				{rol.length > 0 && Boolean(idRol) && (
					<CTNTag color="orange-50" size="size-16" className="[ c-pnp-user-mini__role ]">
						{rol.find((opt) => opt.id === idRol)?.descripcion}
					</CTNTag>
				)}
			</div>
		</button>
	);
};
